import { useMemo, useState } from 'react';
import { CourseTimeline } from '../components/CourseTimeline';
import { RoomSelector } from '../components/RoomSelector';
import { ScheduleHeader } from '../components/ScheduleHeader';
import { Toast } from '../components/Toast';
import { mockSchedule } from './mockData';
import { getCoursesForRoom, getScheduleStats } from './scheduleModel';

import '../styles/classroom-schedule.css';

interface ClassroomSchedulePageProps {
  now?: Date;
}

const demoTime = new Date('2026-09-08T18:43:01');

export function ClassroomSchedulePage({ now = demoTime }: ClassroomSchedulePageProps) {
  const [selectedRoomId, setSelectedRoomId] = useState(mockSchedule.rooms[0]?.id ?? '');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [toast, setToast] = useState<string | null>(null);
  const selectedRoom = mockSchedule.rooms.find((room) => room.id === selectedRoomId);
  const courses = useMemo(() => getCoursesForRoom(mockSchedule.courses, selectedRoomId), [selectedRoomId]);
  const stats = useMemo(() => getScheduleStats(mockSchedule.courses, now), [now]);

  return (
    <section className="classroom-schedule-kit-v2">
      <div className="schedule-tabs" aria-label="课表和点名页面">
        <button type="button" className="is-active">教室课表</button>
        <button type="button" disabled title="暂未接入">刷卡考勤</button>
        <button type="button" disabled title="暂未接入">刷卡记录</button>
      </div>
      <ScheduleHeader date={mockSchedule.date} now={now} stats={stats} onRefresh={() => setToast('已使用 mock 数据刷新课表')} />
      <div className="schedule-workbench">
        <RoomSelector rooms={mockSchedule.rooms} selectedRoomId={selectedRoomId} viewMode={viewMode} onSelect={setSelectedRoomId} onViewModeChange={setViewMode} />
        <CourseTimeline room={selectedRoom} courses={courses} now={now} onPoint={(course) => setToast(`已打开“${course.name}”的点名演示`)} onAction={(course) => setToast(`“${course.name}”的操作菜单由目标项目接入`)} />
      </div>
      <Toast message={toast} />
    </section>
  );
}
